const openNav = ($mainMenu) => {
  $mainMenu.classList.add('--open')
}

const closeNav = ($mainMenu) => {
  $mainMenu.classList.remove('--open')
}

class hm {
  constructor() {
    this.dom = {
      'mainMenu': document.querySelector('.main-menu'),
      'nav': document.querySelector('.main-menu nav'),
      'hmLbl': document.querySelector('.hamburger-menu').querySelector('label'),
      'hmInp': document.querySelector('.hamburger-menu').querySelector('input')
    }
  }
  main() {
    if (!this.dom.hmLbl)
      return false

    this.dom.hmInp.addEventListener('change', (e) => {
      if (e.target.checked) {
        openNav(this.dom.mainMenu)

        return false
      }

      closeNav(this.dom.mainMenu)
    })

    this.dom.hmLbl.addEventListener('click', (e) => {
      e.stopPropagation()
    })
/*
    this.dom.nav.addEventListener('click', (e) => {
      e.stopPropagation()
    })*/

    document.addEventListener('click', (e) => {
      if (this.dom.mainMenu.classList.contains('--open')) {
        this.dom.hmInp.checked = false
        closeNav(this.dom.mainMenu)
      }
    })
  }
}

export default hm
